// -----------------------------------------------------------------------
// <copyright company="Microsoft Corporation">
// Copyright (c) Microsoft Corporation. All rights reserved.
// </copyright>
// -----------------------------------------------------------------------

import { OnePlayerError } from '../common/onePlayerError';
import type { IEmbedLoader, IEmbedLoaderOptions, KnownErrors } from '../types/external';
import { WebinarGenericFileEmbedLoader } from './webinarGenericFileEmbedLoader';

/**
 * Creates an IEmbedLoader that loads videos in the Generic File Iframe Specific for Webinar use case.
 *
 * @param options - The non-video-specific options to use when creating the loader.
 */
export function createWebinarGenericFileEmbedLoader(options: IEmbedLoaderOptions): IEmbedLoader {
  let knownError: KnownErrors | undefined = 'beginSilentSignOn';
  try {
    options.tokenRetriever.beginSilentSignOn();
    knownError = 'iframeUnknown';
    return new WebinarGenericFileEmbedLoader(options);
  } catch (error: unknown) {
    if (error instanceof OnePlayerError) {
      throw error;
    } else {
      throw OnePlayerError.createGenericError('fatal', 'loadIframe', knownError, error);
    }
  }
}
